import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';

export const IdMissionCloseButton = withConfig(theme => styled('button', { label: 'IdMissionCloseButton' })`
    position: fixed;
    top: 12px;
    right: 12px;
    z-index: ${theme.star.zIndexIdMission.idMission};
    width: 32px;
    height: 32px;
    border: none;
    border-radius: 4px;
    background: ${theme.star.idMission.bgColorPrimary};
    cursor: pointer;
    padding: 8px;
    display: flex;
`);

export const HideNativeIdMissionCloseButton = withConfig(theme => styled('div', { label: 'HideNativeIdMissionCloseButton' })`
    position: relative;
    z-index: ${theme.star.zIndexIdMission.processingOverlay};
    /* stylelint-disable no-descending-specificity */
    div > div > div > button:has(svg) {
        display: none;
    }

    div > div > button:has(svg) {
        display: none;
    }

    div > button:has(svg) {
        display: none;
    }
    /* stylelint-enable no-descending-specificity */
`);

export const ErrorWrapper = styled('div', { label: 'ErrorWrapper' })`
    padding: 16px;
`;

export const LoaderWrapper = styled('div', { label: 'LoaderWrapper' })`
    position: absolute;
    top: -100px;
    left: 50%;
    transform: translate(-50%, -50%);
`;

export const ProcessingOverlay = withConfig(theme => styled('div', { label: 'ProcessingOverlay' })`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: ${theme.star.idMission.bgColorTertiary};
    z-index: ${theme.star.zIndexIdMission.processingOverlay};
`);
